import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export const ProfilePage: React.FC = () => {
  const { user } = useAuthStore();

  // Redirect based on user role
  if (user?.role === 'professional') {
    return <Navigate to="/professional/profile" replace />;
  } else if (user?.role === 'opdrachtgever') {
    // Redirect to employer profile page
    return <Navigate to="/employer/profile" replace />;
  } else if (user?.role === 'admin') {
    return <Navigate to="/admin/profile" replace />;
  }

  // If no user or unknown role, redirect to dashboard
  return <Navigate to="/dashboard" replace />;
};
